// extracted by mini-css-extract-plugin
export default {"cta":"cI-z","disabled":"dI-z"};